import { get } from 'svelte/store';
import { format } from 'svelte-i18n';

import { home_data } from 'src/stores/account/user';
import { rooms } from 'src/stores/lists/rooms';
import type { Room } from 'src/types/Room';
let _format = get(format);

export const HiddenDevicesRoomID = -10;
export const SharedRecentlyDevicesRoomID = -20;
export const OfflineDevicesRoomID = -30;
export const SharedAllDevicesRoomID = -40;

export function deriveRoomName(roomID) {
	return roomID == HiddenDevicesRoomID
		? _format('hidden_devices', { default: 'hidden devices' })
		: roomID === SharedRecentlyDevicesRoomID
			? _format('shared_devices', { default: 'shared devices' })
			: get(rooms)[roomID]?.name;
}

export const HiddenRoomObject: Room = {
	id: HiddenDevicesRoomID,
	name: 'hidden_devices',
	image: get(home_data)?.general?.image || 'images/home_def/home_def.jpg',
	position: -10,
	main_sensor: false,
};

export const SharedRoomObject: Room = {
	id: SharedRecentlyDevicesRoomID,
	name: 'shared_devices',
	image: get(home_data)?.general?.image || 'images/home_def/home_def.jpg',
	position: -20,
	main_sensor: false,
};
